// extracted by mini-css-extract-plugin
module.exports = {"root":"CardAvatar_root__95Scr","root-hero":"CardAvatar_root-hero__GtYkC","image":"CardAvatar_image__T2tYJ","root-tile-wit-image":"CardAvatar_root-tile-wit-image__7uPs_"};